module.exports = __webpack_public_path__ + "static/media/discover-incentives-no-hover.b13283ce.svg";